import { globalKeys } from 'assets/data/global-keys';

export default defineNuxtPlugin({
  name: 'banner-tag',
  parallel: true,
  hooks: {
    'app:mounted': async () => {
      const { $marketingService, $storageService } = useServices();
      const route = useRoute();
      const originalQueryString = $storageService.getCookie({
        key: globalKeys.marketingKeys.originalQueryString,
      });

      const setQueryStringParams = () => {
        const websiteUrl = window.location.href;

        const t = websiteUrl.split('?');
        if (t.length > 1)
          $storageService.setCookie({
            key: globalKeys.marketingKeys.originalQueryString,
            data: t[1],
            expiry: 0,
          });
        else
          $storageService.setCookie({
            key: globalKeys.marketingKeys.originalQueryString,
            data: '/',
            expiry: 0,
          });
      };

      const masterToken = $storageService.getCookie({
        key: globalKeys.marketingKeys.masterToken,
      });
      const sessionToken = $storageService.getCookie({
        key: globalKeys.marketingKeys.sessionToken,
      });

      const referrer =
        document.referrer.replace(/\?.*/gm, '') || window.location.origin;
      const currentBtag = $storageService.getCookie({
        key: globalKeys.marketingKeys.bannerTag,
      });

      setInterval(() => {
        if (!currentBtag && !!route.query.btag) {
          $storageService.setCookie({
            key: globalKeys.marketingKeys.bannerTag,
            data: String(route.query.btag),
            expiry: 0,
          });
          $storageService.setCookie({
            key: globalKeys.marketingKeys.referrerBannerTag,
            data: String(route.query.btag),
            expiry: 0,
          });
        } else if (!!currentBtag && !!route.query.btag) {
          $storageService.setCookie({
            key: globalKeys.marketingKeys.referrerBannerTag,
            data: String(route.query.btag),
            expiry: 0,
          });
        }
      }, 5000);

      try {
        if (!originalQueryString || originalQueryString === '/')
          setQueryStringParams();
        if (!sessionToken || !masterToken)
          await $marketingService.fetchOriginTokens();
        if (!currentBtag) await $marketingService.fetchBannerTags({ referrer });
      } catch (e) {
        console.error(e);
      }
    },
  },
});
